import { makeHttpRequest } from "@/shared";

import { mapCalculatedRepairFromServer } from "./mappers/mapCalculatedRepairFromServer";
import { mapRepairAdditionalServiceToServer } from "./mappers/mapRepairAdditionalServiceToServer";
export const removeRepairAdditionalService = async (sessionKey, service) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/builder/${sessionKey}/remove/service/additional`,
            method: "DELETE",
            data: mapRepairAdditionalServiceToServer(service),
        })
    ).data;

    return mapCalculatedRepairFromServer(response.data);
};
